module.exports = __webpack_public_path__ + "static/media/de_vertigo.fb49f655.svg";